module.exports = __webpack_public_path__ + "static/media/zoom.3bba4f3b.svg";